import { mapState, mapMutations } from 'vuex'
import { MODULE_NAME, MUTATIONS } from '@/store/filters/constants'

export default {
  name: 'FulltextSearch',
  mixins: [],
  components: {},
  props: {
    iconColor: {
      type: String
    },
    placeholder: {
      type: String,
      default: 'Buscar por nombre'
    }
  },
  data () {
    return {
      open: false
    }
  },
  computed: {
    ...mapState(MODULE_NAME, ['filters']),
    nameFilter () {
      return this.filters.find(f => f.key === 'fulltext').value
    }
  },
  methods: {
    ...mapMutations(MODULE_NAME, [MUTATIONS.SET_FILTER_VALUE]),
    onChange (ev) {
      const value = ev.target.value || null
      this[MUTATIONS.SET_FILTER_VALUE]({ key: 'fulltext', value })
    },
    toggleSearch () {
      this.open = !this.open
      if (this.open && this.$refs.input) {
        this.$refs.input.focus()
      }
    },
    close () {
      if (!this.$refs.input.value) {
        this.open = false
      }
    }
  }
}
